import { TagDescription } from '@reduxjs/toolkit/dist/query'
import { apiSlice } from '..'
import { IPagination, IAvaliacao, IListaAvaliacao, IAvaliarPreRequisitosInterface, IAvaliarEtapa } from './type'
import { getToken } from 'shared/utils/getToken'

interface IFiltros {
  email?: string
  trilha?: string
  edicao?: string
  quantidadePaginas?: number
  pagina?: number
  tamanho?: number
  url?: string
}
const avaliacaoSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    listReviews: build.mutation<IListaAvaliacao, IPagination>({
      query: data => ({
        url: 'avaliacao',
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
        params: {
          pagina: data.pagina,
          sort: 'idAvaliacao',
          tamanho: 20,
          order: 0
        }
      })
    }),
    avaliarCandidato: build.mutation<void, IAvaliacao>({
      query: data => ({
        url: `avaliacao?token=${getToken()}`,
        method: 'POST',
        body: data,
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Inscricao' as const, id: arg.idInscricao },
        { type: 'Inscricoes' as const }
      ]
    }),
    reavaliarPreRequisitosInscricao: build.mutation<void, IAvaliacao>({
      query: data => ({
        url: `avaliacao/pre-requisitos?token=${getToken()}`,
        method: 'PUT',
        body: data,
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Inscricao' as const, id: arg.idInscricao },
        { type: 'Inscricoes' as const }
      ]
    }),
    getAvaliacaoFiltro: build.mutation<IListaAvaliacao, IFiltros>({
      query: data => ({
        url: `avaliacao/filtro-avaliacao?${data.url}`,
        method: 'GET',
        headers: { Authorization: `Bearer ${getToken()}` }
      })
    }),
    avaliarPreRequisitosInscricoes: build.mutation<void, IAvaliarPreRequisitosInterface>({
      query: data => ({
        url: `avaliacao/pre-requisitos?token=${getToken()}`,
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        body: data
      }),
      invalidatesTags: (result, error, arg) => [
        ...arg.inscricoesIds.map((id: number) => ({ type: 'Inscricao' as const, id })),
        { type: 'Inscricoes' as const }
      ]
    }),
    avaliarPreRequisitosTodasInscricoes: build.mutation<void, void>({
      query: () => ({
        url: `avaliacao/pre-requisitos/todas?token=${getToken()}`,
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` }
      }),
      invalidatesTags: ["Inscricoes", "Inscricao"]
    }),
    avaliarEtapa: build.mutation<void, IAvaliarEtapa>({
      query: (data) => ({
        url: `avaliacao/etapa/${data.idInscricao}/${data.idEtapa}`,
        method: "PUT",
        headers: { Authorization: `Bearer ${getToken()}` },
        body: {...data.body}
      }),
      invalidatesTags: ["Inscricoes", "Inscricao"]
    }),
    importarAvaliacoes: build.mutation<void, { idEtapa: number; arquivo: File }>({
      query: ({ idEtapa, arquivo }) => {
        const formData = new FormData();
        formData.append('arquivo', arquivo);

        return {
          url: `avaliacao/importar/${idEtapa}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${getToken()}` },
          body: formData,
        };
      },
      invalidatesTags: ["Inscricoes"]
    }),
    avaliarTodasInscricoesEtapa: build.mutation<void, number>({
      query: (idEtapa) => ({
        url: `avaliacao/${idEtapa}`,
        method: 'PUT',
        headers: { Authorization: `Bearer ${getToken()}` },
      }),
      invalidatesTags: ["Inscricoes"]
    })
  }),

  overrideExisting: false
})

export const {
  useListReviewsMutation,
  useAvaliarCandidatoMutation,
  useGetAvaliacaoFiltroMutation,
  useAvaliarPreRequisitosTodasInscricoesMutation,
  useAvaliarPreRequisitosInscricoesMutation,
  useReavaliarPreRequisitosInscricaoMutation,
  useAvaliarEtapaMutation,
  useImportarAvaliacoesMutation,
  useAvaliarTodasInscricoesEtapaMutation
} = avaliacaoSlice
